module.exports = __webpack_public_path__ + "static/assets/f83945038c84bedab28ecdf923b35344.png";